module.exports = __webpack_public_path__ + "img/join_group_mob.124cdb76.svg";